module.exports = __webpack_public_path__ + "img/profile1.63f9959f.svg";